export default {
  UPDATE_MESSAGES_COUNT: 'UPDATE_MESSAGES_COUNT',
  UPDATE_NOTIFICATIONS_COUNT: 'UPDATE_NOTIFICATIONS_COUNT',
};



// WEBPACK FOOTER //
// ./src/modules/websockets/actionTypes.js